






import { Component, Vue } from 'vue-property-decorator'
@Component({
  name: 'FoodSafety'
})
export default class FoodSafety extends Vue {

}
